import { ArrowRight } from 'lucide-react'
import { useState } from 'react'

import { dismissOneStemTransitionAnnouncement } from '@/lib/one-stem-transition'
import { Button } from '@/components/ui/button'
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from '@/components/ui/dialog'
import { Typography } from '@/components/ui/typography'
import { LegacyTukiosFlowersBrand } from './LegacyTukiosFlowersBrand'
import { OneStemBrand } from './OneStemBrand'

export function OneStemTransitionAnnouncement({
  initiallyOpen = false,
  onDismiss = dismissOneStemTransitionAnnouncement,
}: {
  initiallyOpen?: boolean
  onDismiss?: () => void
}) {
  const [open, setOpen] = useState(initiallyOpen)

  if (!initiallyOpen) {
    return null
  }

  const handleOpenChange = (nextOpen: boolean) => {
    setOpen(nextOpen)

    if (!nextOpen) {
      onDismiss()
    }
  }

  return (
    <Dialog open={open} onOpenChange={handleOpenChange}>
      <DialogContent size="large" viewport="scroll">
        <DialogHeader className="items-center text-center sm:text-center">
          <Typography variant="label" tone="interaction">
            The same platform. The same team. A new name.
          </Typography>

          <div className="grid w-full grid-cols-[minmax(0,1fr)_auto_minmax(0,1fr)] items-center gap-3 rounded-2xl border border-border/50 bg-elevated p-4 dark:border-border/40">
            <div className="flex min-w-0 justify-center">
              <LegacyTukiosFlowersBrand className="h-14 w-auto max-w-full" />
            </div>
            <ArrowRight aria-hidden="true" className="size-4 shrink-0 stroke-muted-foreground" />
            <div className="flex min-w-0 justify-center">
              <OneStemBrand className="h-14 max-w-full" />
            </div>
          </div>

          <DialogTitle className="text-center text-2xl">Tukios Flowers is now OneStem</DialogTitle>
          <DialogDescription className="max-w-[56ch] text-center text-base/7 sm:text-sm/6">
            You’re in the right place. Tukios Flowers has a new name and a new look.
          </DialogDescription>
        </DialogHeader>

        <div className="grid gap-3 rounded-2xl border border-border/40 bg-elevated/60 p-4 dark:bg-elevated/40">
          <Typography variant="body" tone="muted" className="sm:text-sm/6">
            The platform you use and the team supporting you are still the same. There’s nothing you
            need to do—sign in as usual and keep running your shop.
          </Typography>
          <Typography variant="body" tone="muted" className="sm:text-sm/6">
            OneStem is the next step in building one platform around the real needs of independent
            florists.
          </Typography>
        </div>

        <DialogFooter className="sm:justify-center">
          <Button type="button" onClick={() => handleOpenChange(false)}>
            Continue to OneStem
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  )
}
